import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 8px;
`;

export const Link = styled.a`
  background-color: rgba(29, 29, 29, 1);
  display: flex;
  min-height: 36px;
  align-items: center;
  gap: 10px;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 10px;
  border-radius: 40px;
  transition: background-color 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: rgba(29, 29, 29, 0.85);
  }
`;

export const Icon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  align-self: stretch;
  margin: auto 0;
`;
